<template>
  <el-dialog title="预览" :visible.sync="currentValue" width="70%" custom-class="reviewDialogStyle" top="0" append-to-body>
    <Reviews :html="html"></Reviews>
  </el-dialog>
</template>
<script>
import Reviews from '../reviews'
export default {
  props: ['value', 'html'],
  components: {
    Reviews
  },
  data() {
    return {

    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    },
  }
}
</script>
<style lang="scss">
.reviewDialogStyle {
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
  position: absolute;
  top: 15px !important;
  bottom: 15px;
  left: 50%;
  transform: translate(-50% ,0) !important;
  height: 100%;
  min-width: 960px;
  .el-dialog__header {
    padding: 11px 22px;
  }
  .el-dialog__header {
    border-bottom: 1px solid rgba(32,32,32,0.08);
  }
  .el-dialog__body {
    height: 0;
    flex: 1;
    font-size: initial;
    padding-top: 0;
  }
  .el-dialog__headerbtn {
    top: 10px;
  }
}
</style>
